import tree from "../../../components/tree.vue"
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { emailRule, domainName } from '@/utility/index.js'

export default {
    name: "JurisdictionalCompanies",
    components: { tree, iTable, IPagination },
    data() {
        return {
            formInline: {
                noteTitle: '',
                companyName: '',
                noteState: '',
                createTime: [],
            },
            StateList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('GovernmentRegulation.waitReply')
                },
                {
                    value: '1',
                    label: this.$t('GovernmentRegulation.haveReplied')
                },
                {
                    value: '2',
                    label: this.$t('GovernmentRegulation.haveClosed')
                }
            ],
            dialogVisible: false,
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "noteTitle",
                    label: this.$t('GovernmentRegulation.noteTitle'),
                    align: "center",
                    width: "260px"
                },
                {
                    prop: "describe",
                    label: this.$t('GovernmentRegulation.describe'),
                    align: "center",
                    width: "260px"
                },
                {
                    prop: "companyName",
                    label: this.$t('common.companyName'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "noteState",
                    label: this.$t('GovernmentRegulation.noteState'),
                    align: "center",
                    width: "160px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.noteState === null ? '' : params.row.noteState === 0 ? 'warning' : params.row.noteState === 1 ? 'success' : 'danger' }
                        }, params.row.noteState === null ? '' : params.row.noteState === 0 ? this.$t('GovernmentRegulation.waitReply') : params.row.noteState === 1 ? this.$t('GovernmentRegulation.haveReplied') : this.$t('GovernmentRegulation.haveClosed'))
                    }
                },
                {
                    prop: "createTime",
                    label: this.$t('common.setUpTime'),
                    align: "center",
                    width: "260px"
                },
                {
                    prop: "updateTime",
                    label: this.$t('common.updateTime'),
                    align: "center",
                    width: "260",
                },
                {
                    prop: "lastUser",
                    label: this.$t('common.lastUser'),
                    align: "center",
                    width: "200",
                }
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        dialogFormVisible: false,
                        method: (index, row) => {
                            console.log(row)
                            this.$router.push({
                                path: '/GovernmentRegulation/EnforcementNotes/NoteDetail',
                                query: {oddNum: row.oddNum}
                            })
                        }
                    }
                ],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
        };
    },
    created() {
        
    },
    mounted() {
        this.getJurisdictional()
    },
    methods: {
        getJurisdictional() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.createTime) {
                if (this.formInline.createTime.length > 0) {
                    startTime = this.formInline.createTime[0]
                    endTime = this.formInline.createTime[1]
                }
            }
            let param = {
                jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
                noteTitle: this.formInline.noteTitle,
                companyName: this.formInline.companyName,
                noteState: this.formInline.noteState,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('EnforcementNotes/GET_GETEXECUTELAWNOTE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            })
        },
        onSearch() {
            this.currentPage = 1
            this.getJurisdictional()
        },
        onClear() {
            this.formInline = {
                noteTitle: '',
                companyName: '',
                noteState: '',
                createTime: [],
            }
            this.getJurisdictional()
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getJurisdictional();
        },

        downCar() {
            if (domainName) {
                let startTime = ''
                let endTime = ''
                if (this.formInline.createTime) {
                    if (this.formInline.createTime.length > 0) {
                        startTime = this.formInline.createTime[0]
                        endTime = this.formInline.createTime[1]
                    }
                }
                if (domainName.split(':')[0] !== 'localhost') {
                    let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
                    let url = `https://${domainName}/v1/getExportExcel/exportExecuteLawNote?jurisdictionNum=${jurisdictionNum}&noteTitle=${this.formInline.noteTitle}&companyName=${this.formInline.companyName}&noteState=${this.formInline.noteState}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportExecuteLawNote?jurisdictionNum=${jurisdictionNum}&noteTitle=${this.formInline.noteTitle}&companyName=${this.formInline.companyName}&noteState=${this.formInline.noteState}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
    },
};
